import Alert from '@mui/material/Alert'
import type { InstrumentInfoEntryViewState } from '../lib/types'
import {
  INSTRUMENT_INFO_ALREADY_COMPLETED,
  INSTRUMENT_INFO_CLOSED,
} from '../lib/instrument-info-messages'
import { surveyEntryStatusAlertSx } from '../styles/surveyEntryStyles'

interface InstrumentInfoStatusAlertProps {
  readonly viewState: InstrumentInfoEntryViewState
}

function messageForState(viewState: InstrumentInfoEntryViewState): string | null {
  switch (viewState) {
    case 'alreadyCompleted':
      return INSTRUMENT_INFO_ALREADY_COMPLETED
    case 'capacityReached':
    case 'paused':
    case 'notEligible':
      return null
    case 'closed':
      return INSTRUMENT_INFO_CLOSED
    default:
      return null
  }
}

export function InstrumentInfoStatusAlert({ viewState }: InstrumentInfoStatusAlertProps) {
  const message = messageForState(viewState)
  if (!message) return null

  const severity = 'info' as const

  return (
    <Alert
      severity={severity}
      sx={surveyEntryStatusAlertSx}
      data-testid="instrument-info-status-alert"
    >
      {message}
    </Alert>
  )
}
